import React from 'react'
import Heading from 'shared/ui/Heading'
import Card from '../Card'

export default function PurchaseSuccessMessage({ code, tickets }) {
  return code ? (
    <Card className="spacing">
      <Heading>
        Purchase Successful{' '}
        <span role="img" aria-label="confetti">
          🎉
        </span>
      </Heading>
      <p>
        We're stoked you'll be at our workshop! Your confirmation number for{' '}
        <strong>{tickets}</strong> ticket{tickets > 1 && 's'} is:
      </p>
      <p>
        <code>{code}</code>
      </p>
      <p>
        Stripe will also send you an email receipt so be sure to keep that for your records. We'll
        send an email to {tickets > 1 ? 'all your registered attendees' : 'you'} with instructions
        on downloading the workshop code and other instructions when the workshop is just a few days
        away.
      </p>
      <p>See you soon...</p>
    </Card>
  ) : (
    <Card className="spacing">
      <Heading>
        Purchase Successful{' '}
        <span role="img" aria-label="confetti">
          🎉
        </span>
      </Heading>
      <p>We're stoked you'll be at our workshop!</p>
      <p>
        We'll send an email to {tickets > 1 ? 'all your registered attendees' : 'you'} with
        instructions on downloading the workshop code and other instructions when the workshop is
        just a few days away.
      </p>
      <p>See you soon...</p>
    </Card>
  )
}
